export const CONNECTED_ACCTS = {
  ALREADY_CONNECTED:
    "Your Google account is already connected. If you'd like you can ",
  CONNECT_GOOGLE_ACCOUNT: "Connect Google Account",
  DESCRIPTION:
    "Connect your accounts to get more without leaving Lendflow. Manage aliases and email signature in Aliases",
  DESCRIPTION_SECONDARY:
    "Connected accounts allow sending and receiving emails.",
  DISCONNECT_ACCOUNT: "Disconnect Account",
  DISCONNECT_ACCOUNT_DESCRIPTION:
    "New data will no longer be synchronized, and some features will become unavailable. Previously imported data will remain in the system.",
  NO_CONNECTIONS: "There are no connected accounts yet",
  RECONNECT_ACCOUNT: "reconnect your account.",
  TITLE: "Connected Accounts"
};
